import React from "react"

import Layout from "../components/layout"
import { CHECKOUT_PAGE_URL } from "../helpers/constants"
import queryString from "query-string"

const CheckoutSuccess = props => {
  let urlParams = {}
  let { location } = props

  if (location && location.search) {
    urlParams = queryString.parse(location.search)
  }
  return (
    <Layout {...props}
      minHeight="10rem">
      {urlParams.id && (
        <iframe
          src={`${CHECKOUT_PAGE_URL}/success?id=${urlParams.id}`}
          style={{ width: "100%", height: "90vh", border: "none" }}
        />
      )}
    </Layout>
  )
}

export default CheckoutSuccess
